package io.horion.cv.models

enum class ViewMode {
    GRID, LIST
}